module.exports = __webpack_public_path__ + "static/img/Body_temp.b4d41c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Body_temp.jpg
// module id = aO+T
// module chunks = 0